import update from 'immutability-helper';
import { INIT_GOOGLE_PHOTOS, RECEIVE_GOOGLE_PHOTOS_IMAGES } from '../../constants/ActionTypes';

const initialState = {
  connected: false,
  connectUrl: null,
  images: [],
  nextPageToken: null,
  hasMore: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_GOOGLE_PHOTOS:
      return update(state, {
        images: {
          $set: [],
        },
        nextPageToken: {
          $set: null,
        },
        hasMore: {
          $set: true,
        },
        connected: {
          $set: false,
        },
        connectUrl: {
          $set: action.connectUrl,
        },
      });
    case RECEIVE_GOOGLE_PHOTOS_IMAGES:
      return update(state, {
        images: {
          $push: action.images,
        },
        nextPageToken: {
          $set: action.nextPageToken,
        },
        hasMore: {
          $set: action.nextPageToken != null,
        },
        connected: {
          $set: true,
        },
        connectUrl: {
          $set: null,
        },
      });
  }
  return state;
};
